import { cn } from '../../../helpers/classBuilders';
import { useClassHelper } from '../../../hooks';
import { IconRenderer } from '../../IconRenderer';
import { Button } from './Button';

const successKeys = [
  'watch_activation_success_title',
  'watch_activation_success_paragraph',
  'family_plan_watch_activation_success_title',
  'family_plan_watch_activation_success_paragraph',
];

interface FeedbackSectionProps {
  componentName: string;
  style: Record<string, any>;
  isSubmitting: boolean;
  onClick: () => void;
  text: {
    submitting_title: string;
    success_title: string;
    close_button: string;
    submitting_paragraph: string;
    success_paragraph: string;
  };
  selectedField: Record<string, string>;
  isPortalPreview?: boolean;
  'data-dd-action-name'?: string;
}
export const FeedbackSection = (props: FeedbackSectionProps) => {
  const {
    submitting_title,
    success_title,
    close_button,
    submitting_paragraph,
    success_paragraph,
  } = props.text;
  const {
    selectedField,
    isSubmitting,
    isPortalPreview,
    'data-dd-action-name': dataDdActionName,
  } = props;
  const componentName = props.componentName || 'c-FeedbackSection';
  const c = useClassHelper(componentName);

  const renderTitle = () => {
    if (selectedField && successKeys.includes(selectedField.field)) {
      return success_title;
    }

    if (isSubmitting) {
      return submitting_title;
    }

    return success_title;
  };

  const renderIconVariant = () => {
    if (selectedField && successKeys.includes(selectedField.field)) {
      return 'success';
    }

    if (isSubmitting) {
      return 'spinner';
    }

    return 'success';
  };

  const renderDescription = () => {
    if (selectedField && successKeys.includes(selectedField.field)) {
      return success_paragraph;
    }

    if (isSubmitting) {
      return submitting_paragraph;
    }

    return success_paragraph;
  };

  return (
    <main className={componentName} style={props.style}>
      <section
        className={`${c('__status')} ${cn(
          'flex-1 shrink basis-0 pt-5 pb-6 px-4',
          {
            'pb-[36px]': isPortalPreview,
          },
        )}`}
      >
        <h1 className={c('__title')}>{renderTitle()}</h1>
        <figure className={c('__status__icon')}>
          <IconRenderer variant={renderIconVariant()} />
        </figure>
        <div className={c('__paragraph')}>{renderDescription()}</div>
        <Button
          aria-disabled={props.isSubmitting}
          disabled={props.isSubmitting}
          onClick={props.onClick}
          data-dd-action-name={dataDdActionName}
          type="button"
        >
          {close_button}
        </Button>
      </section>
    </main>
  );
};
